import React, { useState } from "react";
import TypeIcon from "../../../svgs/type.svg";
import FileUpload from "../../Common/FileUpload";
import { InventoryService } from "../../../network/InventoryService";
import { useNotification } from "../../../../Notifications/NotificationProvider";
import FormField from "../../../../Shared/Form/FormField";

const StockUpdateModal = ({
  showUpdateWarrantyModal,
  setShowUpdateWarrantyModal,
}) => {
  const [inventoryTypeForm, setInventoryTypeForm] = useState("");
  const [formError, setFormError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatchNotification = useNotification();

  const inventoryTypeOptions = [
    {
      value: "",
      label: "Inventory type Device/Sim/Other...",
      isPlaceholder: true,
    },
    { value: "device", label: "Device" },
    { value: "sim", label: "Sim" },
    { value: "other", label: "Other" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "inventoryType") {
      setInventoryTypeForm(value);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ];

      if (allowedTypes.includes(file.type) || file.name.endsWith(".csv")) {
        setUploadedFile(file);
        console.log("File uploaded:", file.name);
      } else {
        dispatchNotification({
          type: "ERROR",
          message: "Please upload only Excel (.xlsx, .xls) or CSV files.",
        });
      }
    }
    event.target.value = "";
  };

  const handleDownloadSample = async () => {
    if (!inventoryTypeForm) {
      dispatchNotification({
        type: "ERROR",
        message: "Please select an inventory type first.",
      });
      return;
    }

    setIsDownloading(true);
    try {
      const endpoint = `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/update-warranty?inventory_type=${inventoryTypeForm}`;
      await InventoryService.downloadSampleFile(
        endpoint,
        "warranty-update-sample.xlsx"
      );

      dispatchNotification({
        type: "SUCCESS",
        message: "Sample file downloaded successfully!",
      });
    } catch (error) {
      console.error("Error downloading sample file:", error);
      dispatchNotification({
        type: "ERROR",
        message: "Failed to download sample file. Please try again.",
      });
    } finally {
      setIsDownloading(false);
    }
  };

  const handleUploadSubmit = async () => {
    if (!inventoryTypeForm) {
      dispatchNotification({
        type: "ERROR",
        message: "Please select an inventory type.",
      });
      return;
    }

    if (!uploadedFile) {
      dispatchNotification({
        type: "ERROR",
        message: "Please upload a file.",
      });
      return;
    }

    setIsUploading(true);
    setFormError("");

    try {
      const response = await InventoryService.updateWarranty(
        inventoryTypeForm,
        uploadedFile
      );

      if (response.is_error === 0) {
        dispatchNotification({
          type: "SUCCESS",
          message: "Warranty updated successfully!",
        });

        setInventoryTypeForm("");
        setUploadedFile(null);
        setShowUpdateWarrantyModal(false);
      } else {
        throw new Error(response.message || "Failed to update warranty");
      }
    } catch (error) {
      console.error("Error updating warranty:", error);

      let errorMessage = "Failed to update warranty. Please try again.";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      setFormError(errorMessage);
      dispatchNotification({
        type: "ERROR",
        message: errorMessage,
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div
      className="inventory-modal-overlay"
      onClick={() =>
        !isUploading && !isDownloading && setShowUpdateWarrantyModal(false)
      }
    >
      <div
        className="inventory-modal stock-update-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="inventory-modal-header">
          <h3>Update stock warranty in bulk</h3>
          <button
            className="close-btn"
            type="button"
            onClick={() =>
              !isUploading &&
              !isDownloading &&
              setShowUpdateWarrantyModal(false)
            }
            disabled={isUploading || isDownloading}
          >
            ×
          </button>
        </div>

        <div className="inventory-modal-body">
          <FormField
            id="inventoryType"
            name="inventoryType"
            title="Inventory Type"
            type="select"
            icon={TypeIcon}
            value={inventoryTypeForm}
            onChange={handleInputChange}
            options={inventoryTypeOptions}
            disabled={isUploading || isDownloading}
            required
          />

          <FileUpload
            setUploadedFile={setUploadedFile}
            handleFileUpload={handleFileUpload}
            handleFileChange={setUploadedFile}
            handleDownloadSample={handleDownloadSample}
            isUploading={isUploading}
            isDownloading={isDownloading}
            isDisabled={isUploading || isDownloading || !inventoryTypeForm}
            uploadedFile={uploadedFile}
          />

          {formError && <div className="inventory-form-error">{formError}</div>}
        </div>

        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={() =>
              !isUploading &&
              !isDownloading &&
              setShowUpdateWarrantyModal(false)
            }
            disabled={isUploading || isDownloading}
          >
            Cancel
          </button>
          <button
            className="submit-btn"
            type="button"
            onClick={handleUploadSubmit}
            disabled={
              isUploading ||
              isDownloading ||
              !inventoryTypeForm ||
              !uploadedFile
            }
          >
            {isUploading ? "Updating..." : "Update Warranty"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockUpdateModal;
